import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

import { editPermissionsKeyPrefix, editPermissionsNs } from '../i18n';

const ns = editPermissionsNs;
const keyPrefix = [editPermissionsKeyPrefix, 'reset_confirmation'].join('.');
export const useResetConfirmationTranslation = (): UseTranslationResponse<
  typeof editPermissionsNs,
  typeof editPermissionsKeyPrefix
> => (useTranslation(ns, { keyPrefix }));
